import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import type { CurrentUser } from '@/api/auth'
import { ThemeToggle } from './ThemeToggle'

export function TopBar({ user }: { user: CurrentUser }) {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        borderBottom: 1,
        borderColor: 'divider',
        position: 'sticky',
        top: 0,
        // O fundo precisa ser sólido: sem ele a tabela aparece por trás ao
        // rolar. `appBar` (1100) fica abaixo do Drawer (1200) e do Dialog
        // (1300), então o detalhe e o wizard seguem por cima do topo.
        zIndex: (theme) => theme.zIndex.appBar,
        bgcolor: 'background.default',
      }}
    >
      <Box>
        <Typography variant="h6" component="p">
          {user.partner.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Transfere Auto
        </Typography>
      </Box>

      <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
        <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
          <Typography variant="body2">{user.name}</Typography>
          <Typography variant="caption" color="text.secondary">
            {user.email}
          </Typography>
        </Box>

        <ThemeToggle />
      </Stack>
    </Box>
  )
}
